/*
 * @title App
 * @description Application entry point
 */

// Polyfills

// Misc

// Modules
import sidebar from 'Modules/sidebar/sidebar';
import filters from 'Modules/filters/filters';
import showPassword from './modules/showPassword';
import textareaResize from './modules/textareaResize';
import amountProduct from './modules/amountProduct';
import dropdown from './modules/dropdown';

// Components
import smoothScroll from 'Components/smooth-scroll';
import collapse from 'Components/collapse.js';

document.addEventListener('DOMContentLoaded', function() {
  // Modules
  sidebar();
  filters();
  showPassword();
  textareaResize();
  amountProduct();
  dropdown();
  
  // Components
  smoothScroll();
  collapse();

  const FloatLabel = (() => {
  
    // add active class
    const handleFocus = (e) => {
      const target = e.target;
      target.parentNode.classList.add('active');
     };
    
    // remove active class
    const handleBlur = (e) => {
      const target = e.target;
      if(!target.value) {
        target.parentNode.classList.remove('active');
      }
    };  
    
    // register events
    const bindEvents = (element) => {
      const floatField = element.querySelector('input');
      floatField.addEventListener('focus', handleFocus);
      floatField.addEventListener('blur', handleBlur);    
    };
    
    // get DOM elements
    const init = () => {
      const floatContainers = document.querySelectorAll('.input-floating');
      
      floatContainers.forEach((element) => {
        if (element.querySelector('input').value) {
            element.classList.add('active');
        }      
        
        bindEvents(element);
      });
    };
    
    return {
      init: init
    };
  })();
  
  FloatLabel.init();
  
});
